// extracted by mini-css-extract-plugin
module.exports = {"ConfirmTransfer":"ConfirmTransfer-34baS","Title":"Title-MXRpK","Paragraph":"Paragraph-Xllvi","Pink":"Pink-3RmyJ"};